import { SETTINGS_TABS } from "@/components/layout/nav"
import { TabStrip } from "@/components/layout/tab-strip"
import { ADMIN_ROLE } from "@/lib/api"
import { useAuth } from "@/lib/auth"

/**
 * Полоса вкладок Settings: «Account & people», журнал действий и таймауты.
 *
 * Общая для всех страниц раздела, а не `SettingsLayout` с `Outlet`: у Settings нет
 * общего содержимого, только шапка, и обёртка ради неё заставила бы перенести
 * маршрут `/settings`, на который уже ведут ссылки и снимки приёмки AMEND-8.
 *
 * Не админу полосы нет вовсе: у него осталась бы одна вкладка, а полоса из
 * одной вкладки выглядит как недорисованная.
 */
export function SettingsTabs() {
  const { identity } = useAuth()
  const isAdmin = identity?.role === ADMIN_ROLE
  const tabs = SETTINGS_TABS.filter((tab) => isAdmin || !tab.adminOnly)
  if (tabs.length < 2) return null
  return <TabStrip label="Settings tabs" tabs={tabs} />
}
